export const formatDate = (lng, value) =>
  new Intl.DateTimeFormat(lng, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(new Date(value));
